var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNotTrue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_-_True",
    width: 24,
    height: 24,
    "data-name": "Icon - True",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1,.cls-3{fill:#fff}.cls-1{opacity:0}.cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M0 0h24v24H0z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "frame",
    d: "M0 0h16v16H0z",
    className: "cls-1",
    transform: "translate(4 4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2592",
    "data-name": "Group 2592",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_5",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#f54b5e",
    "data-name": "Oval 5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check001_-_E055",
    d: "M-4.925-40.33l-6 6s6.125-5.927 6-6z",
    className: "cls-3",
    "data-name": "check001 - E055",
    transform: "translate(15.923 45.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check001_-_E055-2",
    d: "M-10.921-40.33l6 6s-6.124-5.927-6-6z",
    className: "cls-3",
    "data-name": "check001 - E055",
    transform: "translate(15.923 45.33)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotTrue);
export default __webpack_public_path__ + "static/media/icon-not-true.beafad67fa1867ceb96b3a0c04ca9ded.svg";
export { ForwardRef as ReactComponent };